import React from 'react';
import { Controller, FieldPath, FieldValues } from 'react-hook-form';
import { StyledQuestionFieldContainer } from '../Questionnaires/QuestionnairePage/components/QuestionViewerEditor/QuestionEditor/styles';
import { InputProps } from './types';
import PriceInput from '../Shared/Form/PriceInput/PriceInput';

export interface PriceEditorProps<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>
  extends InputProps<TFieldValues, TName> {
    label?: string;
  }

function PriceEditor<TFieldValues extends FieldValues, TName extends FieldPath<TFieldValues>>({
  control,
  name,
  label,
}: PriceEditorProps<TFieldValues, TName>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <StyledQuestionFieldContainer>
          <PriceInput
            label={label}
            helperText={fieldState.error?.message}
            value={field.value}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => field.onChange(convertStringToNumber(e.target.value))}
            required
          />
        </StyledQuestionFieldContainer>
      )}
    />
  );
}

function convertStringToNumber(value: string): number {
  return parseFloat(value);
}

export default PriceEditor;
